module.exports = __webpack_public_path__ + "img/dichvusanpham.16d55aa7.jpg";